import SiteFooter from '../components/SiteFooter'
import SiteHeader from '../components/SiteHeader'
import { COMPARE, PLANS } from '../plans'
import useWheelScroll from '../useWheelScroll'
import s from './Plans.module.css'

function Mark({ on }: { on: boolean }) {
  return on ? (
    <svg className={s.yes} viewBox="0 0 24 24" aria-label="포함">
      <path d="m5 12.5 4.5 4.5L19 7.5" />
    </svg>
  ) : (
    <span className={s.no} aria-label="미포함">
      —
    </span>
  )
}

export default function Plans() {
  const cards = useWheelScroll<HTMLDivElement>()

  return (
    <div className={s.page}>
      <SiteHeader current="#/plans" />

      <div className={s.body}>
        <div className={s.wrap}>
          <div className={`${s.head} enter`}>
            <h1>요금제</h1>
            <p>
              무료로 시작하고 필요해질 때 올리세요.
              <br />
              약정이 없어 언제든 변경·해지할 수 있습니다.
            </p>
          </div>

          {/* 요약 카드 — 표를 보기 전에 가격부터 */}
          <div className={`${s.cards} enter enter-1`} ref={cards}>
            {PLANS.map((p) => (
              <div key={p.name} className={`${s.card} ${p.best ? s.best : ''}`}>
                {p.best && <span className={s.badgeBest}>가장 많이 선택</span>}
                <h3>{p.name}</h3>
                <p className={s.desc}>{p.desc}</p>
                <div className={s.price}>
                  {p.price}
                  {p.unit && <em>{p.unit}</em>}
                </div>
                {p.note && <span className={s.trial}>{p.note}</span>}
                <a className={`${s.btn} ${p.best ? s.btnPrimary : s.btnGhost}`} href="#/signup">
                  {p.cta}
                </a>
              </div>
            ))}
          </div>

          <h2 className={`${s.ctitle} enter enter-2`}>플랜별 상세 비교</h2>

          {/* 좁은 화면에서는 표만 가로 스크롤 — 페이지 전체가 밀리지 않게 */}
          <div className={`${s.scroll} enter enter-2`}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th scope="col">기능</th>
                  {PLANS.map((p) => (
                    <th key={p.name} scope="col" className={p.best ? s.hiCol : undefined}>
                      <b>{p.name}</b>
                      <em>
                        {p.price}
                        {p.unit}
                      </em>
                    </th>
                  ))}
                </tr>
              </thead>
              {COMPARE.map((g) => (
                <tbody key={g.title}>
                  <tr className={s.grow}>
                    <th scope="colgroup" colSpan={PLANS.length + 1}>
                      {g.title}
                    </th>
                  </tr>
                  {g.rows.map((r) => (
                    <tr key={r.label}>
                      <th scope="row">
                        {r.label}
                        {r.note && <em>{r.note}</em>}
                      </th>
                      {r.v.map((v, i) => (
                        <td key={PLANS[i].name} className={PLANS[i].best ? s.hiCol : undefined}>
                          {typeof v === 'boolean' ? <Mark on={v} /> : v}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ))}
            </table>
          </div>

          <p className={s.notice}>
            표시 가격은 부가세 별도입니다. 자동화 건수는 에이전트가 실행을 한 번 끝낼 때마다 1건으로
            계산합니다.
          </p>
        </div>
      </div>

      <SiteFooter />
    </div>
  )
}
